import React from "react";
import { FaCity } from "react-icons/fa";

function ViewCity({ data }) {

  return (

    <div className="custom-modal-body">

      <div className="model-custum">

        <div className="city-view-icon">
          <FaCity />
        </div>

        <h3>
          {data?.name}
        </h3>

        <div
          className={
            data?.status === "Active"
              ? "view-status-badge active-badge"
              : "view-status-badge inactive-badge"
          }
        >
          {data?.status}
        </div>

        <div className="view-details-grid">

          <div className="view-detail-card">

            <span>City Name</span>

            <h5>
              {data?.name}
            </h5>

          </div>

          <div className="view-detail-card">

            <span>State</span>

            <h5>
              {data?.state_name}
            </h5>

          </div>

        </div>

      </div>

    </div>
  );
}

export default ViewCity;